// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d4-2";
export var aiChatCartContainerExit = "_d4-4";
export var aiChatContainerLarge = "_d4-0";
export var aiChatContainerSmall = "_d4-1";
export var aiChatIcon = "_d4-6";
export var slideInFromRight = "_d4-3";
export var slideOutToRight = "_d4-5";